
import { signal } from "@preact/signals"

/**
 * 记录首页路径用于返回
 */
export const signalIndexPath = signal<string>("")
